export const environment = {
  defaultLanguage: 'en',
  apiUrl: 'https://ldc-api-stage.lds.bluetraker.com',
  kibanaUrl: 'https://kibana.lds.bluetraker.com',
  dateFormat: 'dd.MM.yyyy HH:mm',
  dateFormatWithoutTime: 'dd.MM.yyyy'
};
